import React from "react"

import Pie from "@components/Chart/Pie"

import getPieChartConfig from "./helpers/getPieChartConfig"


const PieChart = ({ data }) => {
  const config = getPieChartConfig(data)

  return (
    <Pie {...config} />
  )
}

export default PieChart
